module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-700.c18ee39.woff2";